import React, { useContext, useEffect, useState } from "react";
import { Button, Row, Modal } from "react-bootstrap";
import SimpleContext from "../context/SimpleContext";
import persianJs from "persianjs";
import right from "../img/right.png";
import { useHistory } from "react-router";
import config from "../../services/config.json";
import axios from "axios";
import Preloader2 from "../common/Preloader2";
import Preloader from '../Preloader/preloader3';

const UserCode = () => {
  const context = useContext(SimpleContext);
  const [counter, setCounter] = useState(60);
  const [show, setShow] = useState(false);
  const [mssge, setmssge] = useState(false);
  const [showmssge, setshowmssge] = useState(false);
  const [UserSmsCode, setUserSmsCode] = useState([]);
  const [message, setmessage] = useState([]);
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [showToast, setshowToast] = useState(false);
  const [showTextToast, setShowTextToast] = useState("");
  const handleClose = () => setShow(false);
  const [loading, setloading] = useState(false);

  // این بخش برای شمارش معکوس برای ارسال مجدد کد احراز هویت است
  useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  },[counter]);



  //   این بخش برای چک کردن تعداد اعداد وارد شده در بخش احراز هویت است که نهایتا باید 4 عدد باشد.
  function maxLengthCheck(object) {
    if (object.value.length > object.maxLength)
      object.value = object.value.slice(0, object.maxLength);
  }

 
  // این تابع برای ارسال مجدد کد احراز هویت نوشته شده که زمانیکه شمارش معکوس 60 ثانیه به اتمام رسید قابل اجراست.
  const SendAgainSms = () => {
    context.checkcustomer()
    setCounter(60)
    // window.location.reload()
  };

  //تابع برای چک کردن و تایید پسورد کاربر
  const setPassForUser = () => {
    if(context.Pass.length>0&&context.ConfirmPass.length>0&&context.Pass===context.ConfirmPass){
      setshowToast(false)
      context.modify()
    }else{
      setshowToast(true)
      if(
        context.Pass.length===0||context.ConfirmPass.length===0
      ){
        setShowTextToast("پر کردن تمامی فیلد ها الزمایست !")
      }else if (context.Pass!==context.ConfirmPass){
        setShowTextToast("رمز عبور با تکرار رمز عبور برابر نیست.!")
      }
    }
  }

  return (
    <div
    style={{
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      height:'100vh'
    }}
  >
    <form onSubmit={(e)=>context.loginUser(e)} className="EnterNumberMAin">
     
      <div className="registerRow1">
        <img
          alt="image"
          src="/images/CoverBack.jpg"
          className="registerbackground"
          style={{padding:'0',height:'50vh'}}
        />
        <img alt="image" src="/images/logo.png" className="registerapilogo" />
      </div>

      <div className="registerRow2">
        <div className="registerRow2">
        
          <div style={{gap:"20px"}} className="registerRow2Row2">
           <div style={{justifyContent:'center',display:'flex',width:'100%'}} className="infodivUserCode">
              <p  style={{margin:'0',fontWeight:'bold',color:'#000',
              fontSize:"14px",display:'flex',justifyContent:'flex-start',width:'95%'}}>کد تایید 4 رقمی را وارد کنید .</p>
            </div>
            <div style={{justifyContent:'center',display:'flex',width:'100%'}}  className="infodivUserCode">
              <p style={{margin:'0',fontWeight:'bold',color:'#000',
              fontSize:"14px",display:'flex',justifyContent:'flex-start',width:'95%'}}>کد تایید برای شماره همراه شما ارسال شد.</p>
            </div>
            <input
              style={{margin:"0"}}
              type="text"
              placeholder="کد احراز هویت"
              className="inputPhone"
              oninput={() => maxLengthCheck()}
              // نهایتا تا 11 عدد میتوان وارد کرد.
              maxlength="11"
              min="0"
              max="9"
              onChange={(e) => {
                context.setcodeofUser(e.target.value);
              }}
            />

           
             <div style={{display:'flex',width:'95%'}}  className="infodivUserCode">
              <p style={{margin:'0',fontWeight:'bold',color:'#000',
              fontSize:"14px",display:'flex',justifyContent:'flex-start',width:'95%',color:'#ff7014'}}>{context.UseInFo.mobile}</p>
            </div>
             
            <div style={{display:'flex',width:'95%',justifyContent:'space-between'}}   className="infodivUserCode">
               {/* شمارش معکوس 60 ثانیه */}
               {counter > 0 ? (
                 <p style={{margin:'0',fontWeight:'bold',color:'#000',
                 fontSize:"14px",display:'flex',justifyContent:'flex-start',width:'65%',color:'#ff7014'}}>ارسال مجدد کد تا {counter} ثانیه دیگر</p>
              ) : (
                  // ارسال مجدد پیامک
                  <p onClick={() => SendAgainSms()} style={{margin:'0',fontWeight:'bold',color:'#000',
                  fontSize:"14px",display:'flex',justifyContent:'flex-start',width:'65%',color:'#ff7014'}} >ارسال مجدد کد تایید</p>
                )}

            {
              context.UseInFo.hasPassword===true&&
              <div style={{display:'flex',width:'30%'}}  className="infodivUserCode">
              <p onClick={()=>history.push("/loginWithCode")} style={{margin:'0',fontWeight:'bold',color:'#000',
              fontSize:"14px",display:'flex',justifyContent:'flex-end',width:'95%',color:'#ff7014'}}>ورود با رمز عبور</p>
              </div>
            }
            </div>
            
          </div>
          {/* اگر تعداد ارقام کمتر از 11 بود، دکمه ثبت و ادامه غیرفعال میشود در غیراینصورت اگر 11 عدد وارد شد، دکمه فعال خواهد شد. */}
          {
          context.preButton===true?
          <button type="button" className="EnterNumberButtonActivated">
          <Preloader/>
          </button>
          :
          (
           (
              <button type="submit" className="EnterNumberButtonActivated">
                تایید و ادامه
              </button>
            )
          ) }
        </div>
      </div>
    </form>

    <Modal style={{marginTop:'50%'}}  show={context.setPassModal}>
      <div style={{gap:'25px'}} className="styleByFlexC" >
        <p style={{marginTop:"15px",width:'90%',fontWeight:'bold',color:"#000",marginBottom:"0"}}>لطفا یک رمز عبور برای خود انتخاب کنید</p>
        <input  onChange={(e) => {
                context.setPass(e.target.value);
              }} style={{margin:"0",width:'90%'}}  className="inputPhone" 
             
                placeholder="رمز عبور"/>
        <input  onChange={(e) => {
                context.setConfirmPass(e.target.value);
              }} style={{margin:"0",width:'90%'}}  className="inputPhone"  
             
               placeholder="تکرار رمز عبور"/>
      {/* نمایش ارور */}
      {
        showToast===true&&
        <p style={{width:'90%',fontWeight:'bold',color:"red",marginBottom:"0",fontSize:'12px'}}>{showTextToast}</p>
      }
      {
      context.preButton===true?
      <button style={{marginBottom:"15px",width:'90%',fontSize:'17px'}} className="EnterNumberButtonActivated">
      <Preloader/>
      </button>
      :
      <button style={{marginBottom:"15px",width:'90%',fontSize:'17px'}} onClick={()=>setPassForUser()} className="EnterNumberButtonActivated">
        تایید
      </button>
           
      }
      </div>
    </Modal>
   
  </div>   
  );
};

export default UserCode;
